<template>
  <div class="sidebar-pinned">
    <Navbar/>
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="header-icon-wrap">
          <i class="fe fe-edit-2"></i>
        </div>
        <div>
          <h2 class="page-header-title">Edit Enrollee</h2>
          <p class="page-header-subtitle">Update offline enrollee information</p>
        </div>
      </div>

      <div class="container mt-n3 pb-5">
        <div class="card info-card shadow-sm">
          <div class="info-card-header">
            <i class="fe fe-edit-2 mr-2"></i> Edit Form
          </div>
          <div class="card-body">
            <OfflineEditForm
              :students="students"
              @add-item="addStudent"
              @remove-item="refreshStudent"
              @update-item="refreshStudent"
            />
          </div>
        </div>
      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </div>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  // Import component
     import Loading from 'vue-loading-overlay';
     // Import stylesheet
     import 'vue-loading-overlay/dist/vue-loading.css';
     // Init plugin
     import OfflineEditForm from "./OfflineEditForm.vue";
     import { initJsStore } from "./../../../service/idb_service";
     import { StudentService } from "./../../../service/student_service";
     import { Global } from "./../../../global";

export default {
  components: {
     Navbar, Loading, OfflineEditForm
  },
  async beforeCreate() {
    try {
      const isDbCreated = await initJsStore();
      if (isDbCreated) {
        console.log("db created");
        // prefill database
      } else {
        console.log("db opened");
      }
    } catch (ex) {
      console.error(ex);
      alert(ex.message);
      Global.isIndexedDbSupported = false;
    }
  },
  mounted() {
    this.refreshStudent();
  },
  data(){
    return{
      isLoading: false,
      fullPage: true,
      states:"",
      clients:"",
      state:"",
      students: [],
      lga_states:"",
      register:{
                firstname:"",
                lastname:"",
                email:"",
                phone_number:"",
                type:"client",
                username:"",
                state:"",
                lga:"",
                ward:"",
                address:"",
            }
    }
  },
  beforeMount(){
    this.user = JSON.parse(localStorage.getItem('user'))
    this.axios.get(`/api/v1/auth/getAgencyToUser/${this.user.id}`)
                .then(response => {
                    this.clients = response.data.data
                    console.log(response)
                })
                .catch(error => {
                    console.error(error);
                })
  },
  methods:{

    getClients(){
      this.user = JSON.parse(localStorage.getItem('user'))
      this.axios.get(`/api/v1/auth/getAgencyToUser/${this.user.id}`)
                  .then(response => {
                      this.clients = response.data.data
                      console.log(response)
                  })
                  .catch(error => {
                      console.error(error);
                  })
    },
    async refreshStudent() {
      this.students = await new StudentService().getStudents();
    },
    addStudent(student) {
      this.students.push(student);
    }


  },
  created(){
    this.getClients()
  }

}
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  padding: 36px 40px 56px;
  display: flex;
  align-items: center;
  gap: 18px;
}
.header-icon-wrap {
  background: rgba(255,255,255,0.15);
  border-radius: 14px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  flex-shrink: 0;
}
.page-header-title  { font-size: 1.6rem; font-weight: 800; margin: 0 0 4px; }
.page-header-subtitle { margin: 0; opacity: .82; font-size: .9rem; }

.info-card { border-radius: 12px; border: 1px solid #e9ecef; overflow: hidden; }
.info-card-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: #fff;
  font-weight: 600;
  font-size: .85rem;
  padding: 10px 16px;
}
</style>
